import loadable from '@loadable/component';
export const manifest = {
  OnlineApplications: {
    device: {
      mobile: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "OnlineApplicationsMobile";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "OnlineApplicationsMobile" */
          './online-application'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./online-application");
            }

            return eval('require.resolve')("./online-application");
          }

        }, {
          resolveComponent: mod => mod.OnlineApplicationsMobile
        })
      }
    }
  },
  'OnlineApplications.Accordion': {
    device: {
      mobile: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "OnlineApplicationsAccordionMobile";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "OnlineApplicationsAccordionMobile" */
          './accordion'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./accordion");
            }

            return eval('require.resolve')("./accordion");
          }

        }, {
          resolveComponent: mod => mod.Accordion
        })
      }
    }
  },
  'OnlineApplications.AccordionItem': {
    device: {
      mobile: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "OnlineApplicationsAccordionItemMobile";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "OnlineApplicationsAccordionItemMobile" */
          './accordion-item'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./accordion-item");
            }

            return eval('require.resolve')("./accordion-item");
          }

        }, {
          resolveComponent: mod => mod.AccordionItem
        })
      }
    }
  },
  'OnlineApplications.GridLayout': {
    device: {
      mobile: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "OnlineApplicationsGridLayoutMobile";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "OnlineApplicationsGridLayoutMobile" */
          './grid-layout'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./grid-layout");
            }

            return eval('require.resolve')("./grid-layout");
          }

        }, {
          resolveComponent: mod => mod.GridLayout
        })
      }
    }
  },
  'OnlineApplications.ArrowLink': {
    device: {
      mobile: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "OnlineApplicationsArrowLinkMobile";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "OnlineApplicationsArrowLinkMobile" */
          './arrow-link'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./arrow-link");
            }

            return eval('require.resolve')("./arrow-link");
          }

        }, {
          resolveComponent: mod => mod.ArrowLink
        })
      }
    }
  },
  OnlineApplicationsToggle: {
    device: {
      mobile: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "OnlineApplicationsToggleMobile";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "OnlineApplicationsToggleMobile" */
          './toggle-button'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./toggle-button");
            }

            return eval('require.resolve')("./toggle-button");
          }

        }, {
          resolveComponent: mod => mod.ToggleButtonMobile
        })
      }
    }
  }
};